import { Component } from '@angular/core';

import { environment } from 'environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent
{
    copyRight = environment.copyrightText;
    envName = environment.envName;
    /**
     * Constructor
     */
    constructor()
    {
    }
}
